;
( function( $, window, document, undefined )
{
    'use strict';

    var PopularTopics = function( options )
    {
        this.init();
    };

    PopularTopics.prototype = {

        init : function()
        {
            this.carousel();
            this.tabs();

            //this.direction = $( '#PDC6-main-container' ).hasClass( 'isAR' ) ? 'right' : 'left';
            this.direction = 'left';
        },

        tabs : function()
        {
            var $sackboy = $( '#support-topics-sackboy' ).addClass( 'visible' )
              , $help    = $( '#popular-topics-help' ).addClass( 'visible' );

            $( '#popular-topics-filters' ).on( 'click', 'a', function( e )
            {
                e && e.preventDefault();

                if( $( this ).parent().hasClass( 'active' ) )
                {
                    return;
                }

                if( $( this ).attr( 'href' ) == '#popular-topics-support' )
                {
                    $sackboy.removeClass( 'visible' );
                    $help.removeClass( 'visible' );
                }

                var $dest = $( $( this ).attr( 'href' ) ).removeClass( 'hidden' ).siblings().addClass( 'hidden' );

                $( this ).parent().addClass( 'current-tab' ).siblings().removeClass( 'current-tab' );
            } );
        },

        carousel : function()
        {
            var frame = {
                step  : null,
                slide : null
            };

            var that = this;

            $( '.popular-topics-carousel' ).each( function()
            {
                var arrowNextId = 'popular-topics-next'
                  , arrowPrevId = 'popular-topics-prev'
                  , $arrows     = $( this ).prevAll( '.popular-topics-arrows' )
                  , $arrowPrev  = $( '.' + arrowPrevId )
                  , $arrowNext  = $( '.' + arrowNextId )
                  , $carousel   = $( this )
                  , $slider     = $carousel.children( 'ul' )
                  , $items      = $slider.children( 'li' )
                  , $firstSlide = $slider.children().eq( 0 )
                  , $pages      = $( this ).prevAll( '.popular-topics-pages' )
                  , pages       = Math.ceil( $items.size() / 5 );

                $arrowPrev.addClass( 'disabled' );

                if( frame.step == null )
                {
                    frame.step = parseInt( $carousel.css( 'width' ) );
                }

                if( frame.slide == null )
                {
                    frame.slide = parseInt( $firstSlide.css( 'width' ) );
                }

                for( var i = 1; i < pages; i++ )
                {
                    $pages.append( '<li><a href="#"></a></li>' );
                }

                $slider.css( 'width', $slider.children().size() * ( frame.slide + parseInt( $firstSlide.css( 'margin-left' ) ) ) );

                $pages.on( 'click', 'li', function( e )
                {
                    e && e.preventDefault();

                    var page = $( this ).index();

                    $( this ).addClass( 'current' ).siblings().removeClass( 'current' );

                    $arrowNext[ !$( this ).next().size() ? 'addClass' : 'removeClass' ]( 'disabled' );
                    $arrowPrev[ !$( this ).prev().size() ? 'addClass' : 'removeClass' ]( 'disabled' );

                    $slider.css( that.direction, ( frame.step * page ) * -1 )[ 0 ].className = 'page-' + page;
                } );

                $arrows.on( 'click', 'a', function( e )
                {
                    e && e.preventDefault();

                    if( $( this ).hasClass( 'disabled' ) )
                    {
                        return false;
                    }

                    $pages.find( '.current' )[ $( this ).hasClass( arrowNextId ) ? 'next' : 'prev' ]().trigger( 'click' );
                } );

            } );
        }

    };

    $.fn.PopularTopics = function( options )
    {
        var args     = Array.prototype.slice.call( arguments, 1 )
          , $item    = $( this )
          , instance = $item.data( 'PopularTopics' );

        if( !instance )
        {
            instance = new PopularTopics( this, options );
            $item.data( 'PopularTopics', instance );
        }

        if( typeof options === 'string' )
        {
            instance[ options ].apply( instance, args );
        }

        return this;
    };

} )( jQuery, window, document );